import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import DocumentTypeMapper from "../../../documentTypes/service/DocumentTypeMapper";
import DocumentTypeParamMapper from "../../../documentTypes/service/DocumentTypeParamMapper";

export default class GetCaseLawDocumentTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      "case-law-documents/types",
      DocumentTypeMapper,
      DocumentTypeParamMapper
    );
  }
}
